"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_INFO = void 0;
const PRODUCT_INFO = exports.PRODUCT_INFO = 'product-info';
